import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CategoryGrid from "@/components/CategoryGrid";
import SEO from "@/components/SEO";

export default function CategoriesPage() {
  const [tree, setTree] = useState([]);

  useEffect(() => {
    api.get("/categories/tree").then(({ data }) => setTree(data));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-testid="categories-page">
      <SEO title="Explore Supplier Categories" description="Your accommodation procurement network, growing category by category. Linen, textiles and soft furnishings are open now; furniture is launching; six more categories are coming soon." path="/categories" />
      <div className="mb-12 max-w-3xl">
        <div className="tracking-overline mb-3">All categories</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#11211A] tracking-tight" data-testid="categories-heading">Explore Supplier Categories</h1>
        <p className="text-base md:text-lg text-[#4A5550] mt-5 leading-relaxed" data-testid="categories-subline">Your accommodation procurement network, growing category by category.</p>
      </div>
      <CategoryGrid categories={tree} testPrefix="categories-grid" />
    </div>
  );
}
